import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import { isEmpty } from "lodash";
import { store } from "redux/store";
import { abovePropUserView } from "utils/CommonConstants";
import { getUserType } from "utils/CommonFunctions";
import { getUserName } from "utils/StoreUtils";
import { userTypes } from "utils/Types";
import { setShowOnboardingWizardFromLibrary } from "./Onboarding.slice";

export const triggerOnboadingWizard = (dispatch: any) => {
  const state = store.getState();
  const isImpersonated = state.app.impersonationDetails?.isImpersonated;
  const { createdDate } = state.Onboarding.checkApiResponse;

  if (isImpersonated && !createdDate) {
    dispatch(
      setFeedbackDetails({
        variant: "warning",
        shouldShow: true,
        setState: setFeedbackDetails({ shouldShow: false }),
        message: `'${getUserName()}' has never logged into BOOST. No data will display. `
      })
    );
  } else {
    dispatch(setShowOnboardingWizardFromLibrary(true));
  }
};

export const triggerNeverLoggedInWarning = (dispatch: any) => {
  const state = store.getState();
  const isImpersonated = state.app.impersonationDetails?.isImpersonated;
  const checkApiResponse = state.Onboarding.checkApiResponse;

  const shouldShowWarning = isImpersonated && !isEmpty(checkApiResponse) && !checkApiResponse.createdDate;

  if (isOnboardingEnabled() && shouldShowWarning) {
    dispatch(
      setFeedbackDetails({
        variant: "warning",
        shouldShow: true,
        setState: setFeedbackDetails({ shouldShow: false }),
        message: `'${getUserName()}' has never logged into BOOST. No data will display. `
      })
    );
  }
  return shouldShowWarning;
};

export const isOnboardingEnabled = () => {
  const state = store.getState();
  const viewAs = state.app.viewAsForAbovePropUser;
  return (
    getUserType() === userTypes.HOTEL_USER ||
    (getUserType() === userTypes.ABOVE_PROPERTY && viewAs !== abovePropUserView["AP"])
  );
};

export const isOnboardingCompleted = () => {
  const state = store.getState();
  const { createdDate } = state.Onboarding.checkApiResponse;

  return !!createdDate;
};
